import { render, staticRenderFns } from "./DeptSelect.vue?vue&type=template&id=817237fe&scoped=true"
import script from "./DeptSelect.vue?vue&type=script&lang=js"
export * from "./DeptSelect.vue?vue&type=script&lang=js"
import style0 from "./DeptSelect.vue?vue&type=style&index=0&id=817237fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817237fe",
  null
  
)

export default component.exports